var React = require('react');

function FooterCurve2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 84.5386C12.5 77.8697 25 44.5227 58.5 27.0003C131.083 -10.9649 164.414 39.5108 179.712 84.5386","stroke":"black","strokeWidth":"6","strokeLinecap":"round","strokeDasharray":"10 20"}));
}

FooterCurve2.defaultProps = {"width":"184","height":"62","viewBox":"0 0 184 62","fill":"none"};

module.exports = FooterCurve2;

FooterCurve2.default = FooterCurve2;
